export default __webpack_public_path__ + "static/media/linkedin.400c860f.svg";